import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  Group,
  Image,
  Loader,
  Modal,
  Paper,
  Select,
  Table,
  Tabs,
  Text,
  TextInput,
  Textarea,
  Title,
  createStyles,
  } from "@mantine/core";
  import { useMedplum } from "@medplum/react";
  import FHIR from "fhirclient";

  import { IconChecklist, IconJson, IconStar, IconTargetArrow } from "@tabler/icons-react";
  import { useEffect, useState } from "react";
  import aiLoader from "../../assets/img/ailoader2.gif"
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  import { fetchGoalsAndTasks } from "../Patient/PatientDetails/CareplanService";
  import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
  import ProgressTracker from "../Eligibility/claims/Steps";
  import CarePlanComponent from "./GoalsAndTasks";
  import { PatientDetails } from "../Eligibility/claims/CustomCards";
  import CarePlanResource from "./CarePlanDetails";
  import { IconSparkles } from "@tabler/icons-react";
  import { showNotification } from "@mantine/notifications";
import ResourceDisplay from "./ResourceView";
  
  const useStyles = createStyles((theme) => ({
  medicalDocPaper: {
  marginTop: "20px",
  borderRadius: "8px",
  marginLeft: "40px",
  marginRight: "40px",
  padding: "20px",
  background: "'#FFF",
  // boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
  },
  table: {
  marginTop: "30px",
  },
  thead: {
  backgroundColor: "#BEDEF8",
  borderRadius: 4,
  },
  heading: {
  fontWeight: 700,
  fontSize: "26px",
  lineHeight: "36px",
  color: "#262930",
  },
  text: {
  border: "1px solid #ddd",
  borderRadius: "5px",
  padding: "12px",
  // marginTop: "25px",
  overflow: "auto",
  wordWrap: "break-word",
  maxWidth: "100%",
  
  },
  }));
  
  interface ReportProps {
  patient?: any;
  embed?:boolean
  }
  
  export const NewCarePlan = ({ patient,embed }: ReportProps) => {
  // useEffect(() => {
  // fetchCarePlan()
  // }, []);
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { code } = useParams();

  const medplum = useMedplum();
  const location = useLocation();

  const patientId = location.state?.patientId;
  const PatientResourceDetails =location?.state?.PatientDetails
  const [carePlans, setcarePlans] = useState<any>([]);
  const [patientData,setPatientData]=useState<any>()
  // const [createCarePlan, setCreateCarePlan] = useState<boolean>(false);
  const [formData, setFormData] = useState({ title: "", description: "" });
  const [errors, setErrors] = useState({ title: false, description: false });
  const [currentStep, setCurrentStep] = useState(0);
  const [creatingGoalsAndTaks ,setCreatingGoalsAndTasks]=useState<boolean>(false)
  const [goalsAndTasks,setGoalsAndTaks]=useState<any>([])
  const [carePlanResource,setCarePlanResource]=useState<any>()
  const[createingCarePlan,setCreatingCarePlan]=useState<any>(false)
  const[EmbedLoading,setEmbedLoading]=useState<any>(false)
  const[embedGoals,setEmbedGoals]=useState<any>([])
  const[embedTasks,setEmbedTasks]=useState<any>([])
const[embedModal,setEmbedModal]=useState<boolean>(false)


  useEffect(() => {
    if(embed){
    fetchData();
    loginWithIdandSecret();
    }
  }, []);
  const handleSelectChange = (selectedLabel:any) => {
  const selectedNote = commonClinicalNotes.find(note => note.label === selectedLabel);
  
  if (selectedNote) {
  setFormData({
  title: selectedNote.label,
  description: selectedNote.value.trim()
  });
  setErrors({title:false ,description:false});
  
  }
  };

  
  const handleChange = (e: any) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
  if (value.trim() !== "") {
  setErrors({ ...errors, [name]: false });
  }
  };
  const handleSubmit = async (e: any) => {
  e.preventDefault();
  setCreatingGoalsAndTasks(true);
  const { title, description } = formData;
  // Basic validation for title and description
  if (title.trim() === "" || description.trim() === "") {
  setErrors({
  title: title.trim() === "",
  description: description.trim() === "",
  });
  setCreatingGoalsAndTasks(false);
  return;
  }
  const payload = {
  eventType: "fetch-goals",
  providerNote: description,
  patientId:embed?patientData?.id: patientId,
  carePlanTitle: title,
  };
  try {
  // Call the fetchGoalsAndTasks function with the payload
  const fetchGoalsandTaskFromNote = await fetchGoalsAndTasks(medplum, payload);
  // Check if response is valid or if goals/tasks are missing
  if (!fetchGoalsandTaskFromNote) {
  showNotification({ color: 'orange', message: 'Please add a goal or task to create a care plan', autoClose: true });
  setCurrentStep(1);
  } else if (Array.isArray(fetchGoalsandTaskFromNote)) {
  // Successfully fetched goals/tasks as an array
  setGoalsAndTaks(fetchGoalsandTaskFromNote);
  setCurrentStep(1);
  } else if (fetchGoalsandTaskFromNote?.statusCode > 300) {
  // Handle response with a status code above 300
  setCurrentStep(0);
  showNotification({ color: 'red', message: `${fetchGoalsandTaskFromNote?.body}`, autoClose: true });
  } else if (fetchGoalsandTaskFromNote?.message?.includes('No goals or tasks found in provided note')) {
  // Specific case for "no goals or tasks found"
  showNotification({ color: 'orange', message: 'Please add a goal or task to create a care plan', autoClose: true });
  setCurrentStep(1);
  }
  } catch (error) {
  // Catch block for handling errors
  console.error("Error fetching goals and tasks:", error);
  setCurrentStep(0);
  showNotification({ color: 'red', message: 'Failed to create care plan, please try again', autoClose: true });
  } finally {
  // Ensure the loading state is reset
  setCreatingGoalsAndTasks(false);
  }
  };
  const createCarePlan = async (goalsAndTasksArray:any,) => {
  const payload = {
  eventType: 'create-goals',
  goalsArray: goalsAndTasksArray,
  patientId: embed?patientData?.id:patientId,
  carePlanTitle:formData.title,
  providerNote: formData?.description,
  };
  setCreatingCarePlan(true)
  
  const response = await fetchGoalsAndTasks(medplum, payload);
  if (response) { if(response==='No goals or tasks found.'){
  setCarePlanResource([])
  setCurrentStep(2)
  setCreatingCarePlan(false)
  return
  }
  
  setCarePlanResource(response)
  setCurrentStep(2)
  setCreatingCarePlan(false)
  }
  };
  
  const steps: {
  label: string;
  status: "completed" | "current" | "upcoming";
  }[] = [
  {
  label: "New Care Plan",
  status: currentStep === 0 ? "current" : "completed",
  },
  {
  label: "Goals And Tasks",
  status:
  currentStep === 1
  ? "current"
  : currentStep > 1
  ? "completed"
  : "upcoming",
  },
  {
  label: "Care Plan Details",
  status: currentStep === 2 ? "current" : "upcoming",
  },
  ];

 
  
  const commonClinicalNotes = [
  {
  label: "Care Plan for Hypertension Management",
  value: "The patient presents with persistently elevated blood pressure readings over the past month. Today’s clinic measurement is 150/95 mmHg, categorized as Stage 2 Hypertension according to ACC/AHA guidelines. The patient denies associated symptoms such as headache, dizziness, blurred vision, chest pain, or shortness of breath. No signs of an acute hypertensive emergency are present, suggesting the condition can be managed with close monitoring and lifestyle modifications. To address the elevated blood pressure, the patient is advised to adopt the DASH diet, which emphasizes reducing sodium intake to less than 1,500 mg per day, increasing consumption of potassium-rich foods like bananas and leafy greens, and incorporating whole grains into meals. Educational materials will be provided, and the patient is encouraged to consult with a dietitian for personalized meal planning if needed. Additionally, the patient is instructed to begin moderate aerobic exercise, such as brisk walking, for at least 30 minutes, five days per week, aiming for a total of 150 minutes of exercise weekly. Resistance training twice weekly can be added as tolerated. Stress management strategies are also recommended, including daily meditation, deep breathing exercises, or progressive muscle relaxation for 10–15 minutes. A mindfulness or stress management app (e.g., Calm, Headspace) may also be helpful. The patient is instructed to monitor their blood pressure at home twice daily, once in the morning and once in the evening, and to log all readings. Proper technique was reviewed during the visit, including sitting quietly for five minutes before measuring and using the same arm consistently with an upper-arm cuff. Accurate monitoring will help track progress and assess the effectiveness of lifestyle interventions. A follow-up visit is scheduled in two weeks to review the home blood pressure logs and reassess management. If the blood pressure remains elevated despite adherence to lifestyle modifications, initiation of antihypertensive medication will be considered."
  },
  {
  label: "Care Plan for Type 2 Diabetes Management",
  value: "The patient presents with an HbA1c of 8.2%, indicating suboptimal blood glucose control. The patient reports difficulty managing blood sugar levels consistently. During the visit, the importance of strict adherence to prescribed medications was emphasized, and adjustments to the diet were discussed. A focus on low-glycemic, balanced meals was recommended to help stabilize blood glucose levels. The patient was instructed on the need for consistent daily blood glucose monitoring and maintaining a detailed log of readings. This will enable better understanding and management of blood sugar patterns. The patient was prescribed metformin 500 mg twice daily and advised to stay well-hydrated. Additionally, light exercise, such as walking for 30 minutes, 5 times a week, was recommended to improve overall glycemic control and support cardiovascular health. A follow-up appointment is scheduled for 3 months to review progress, assess HbA1c levels, and make any necessary adjustments to the treatment plan. Regular communication and adherence to the outlined care plan are essential to achieving the patient’s diabetes management goals."
  },
  {
  label: "Care Plan for Viral Pharyngitis",
  value: "The patient presents with a fever of 102°F, chills, sore throat, and body aches persisting for the past three days. Physical examination reveals pharyngeal erythema and mild cervical lymphadenopathy, consistent with a diagnosis of viral pharyngitis. The patient was advised to prioritize rest and increase fluid intake to stay hydrated and support recovery. For fever and discomfort, the patient is instructed to take acetaminophen as needed, following dosage guidelines. Symptoms should be monitored closely, and the patient was advised to seek medical attention if the fever persists beyond 5 days or if additional symptoms such as difficulty breathing, rash, or worsening throat pain develop. To aid in recovery, the patient was instructed to avoid physical exertion and allow adequate time for the illness to resolve. With proper care, symptoms are expected to improve within a few days. A follow-up visit is recommended if symptoms persist or worsen."
  }
  ];
  const loginWithIdandSecret = async () => {
    try {
setEmbedLoading(true)
      const decodedQuery = decodeURIComponent(code as string);

      const decodeQueryStringWithData = atob(decodedQuery);

      const queryParamss = decodeQueryStringWithData.split(",");
      //   setClientData(queryParamss);
      const id = queryParamss[0];
      const secret = queryParamss[1];

      const login = await medplum.startClientLogin(id, secret);
      if (login) {
setEmbedLoading(false)
        return true;
      }
    } catch (error) {
      setEmbedLoading(false)

      console.error(error);
    }finally{
      setEmbedLoading(false)

    }
  };
  const fetchData = async () => {
    try {
      setEmbedLoading(true)

      const client = await FHIR.oauth2.ready();

      // Get the patient data
      const patientData = await client.patient.read<any>();
      setPatientData(patientData);
      setEmbedLoading(false)

     
    } catch (error) {

      console.error(error);
      showNotification({
        color: "red",
        message: `Error Fetching data: ${error}`,
        autoClose: true,
      });
    }finally{
      setEmbedLoading(false)

    }
  };

  const handleEmbedSubmit =(goalsAndTasksArray:any)=>{
    const goals = goalsAndTasksArray?.filter((item:any) => item?.resourceType === 'Goal');
  const tasks = goalsAndTasksArray?.filter((item:any) => item?.resourceType === 'Task');
  setEmbedGoals(goals)
  setEmbedTasks(tasks)
  setEmbedModal(true)
    // setCurrentStep(0)
    setFormData({title:"",description:""})
    showNotification({
      color: "green",
    message: `Care plan created successfully`,
      autoClose: true,
    });
  }

  
  return (
  <>
  <Paper className={classes.medicalDocPaper}>
  <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
    {!embed &&  <Box>
  <CustomBreadcrumbs />
  </Box>}
 
  
  <Box>
  <Title sx={{display:"flex",justifyContent:"flex-start"}} className={classes.heading}>New Care Plan</Title>
  </Box>
  {!embed &&  <Box
  mb={"16px"}
  bg={"#F1F9FF"}
  p={"16px"}
  sx={{ borderRadius: "8px", width: "100%" }}
  >
  <ProgressTracker steps={steps} />
  </Box>}

 {EmbedLoading?<Box sx={{display:"flex",justifyContent:"center",alignItems:"center"}}> <Loader /></Box>:  <PatientDetails planDetails={true} patient={embed?patientData:PatientResourceDetails}/>
}
  
  <Box sx={{display:"flex",justifyContent:"space-between"}}>
  { currentStep===0 && 
  <Box sx={{display:"flex",justifyContent:"center",alignItems:"center",gap:"8px"}}>
  <Text fz="lg" fw={700}> Create Care Plan</Text>
  </Box>
  }
  {currentStep===0 && !creatingGoalsAndTaks && 
  <Box sx={{display:"flex",justifyContent:"center",alignItems:"center"}}>
  <Button disabled={embed?!patientData:false} type="submit" color="blue" onClick={handleSubmit}>
  <Box mr={'4px'}><IconSparkles color={'white'}/></Box> Generate Care Plan
  </Button>
  </Box>}
  </Box>
  {
  !creatingGoalsAndTaks &&currentStep===0 ? <form onSubmit={handleSubmit}>
  <Select
  label="Select Template"
  placeholder="Ex. Care plan "
  data={commonClinicalNotes.map(note => ({ label: note.label, value: note.label }))}
  size="lg"
  mb={'15px'}
  onChange={handleSelectChange}
  
  />
  <Box mt={'15px'} sx={{display:"flex",flexDirection:"row",gap:"10px" ,justifyContent:"center"}}>
  <Divider w={'48%'} my="sm" variant="dashed" />
  <Text c={'dimmed'}>OR</Text>
  <Divider w={'52%'} my="sm" variant="dashed" />
  
  </Box>
  <TextInput
  mb={'8px'}
  mt={'11px'}
  
  label="Title"
  placeholder="Enter care plan title"
  name="title"
  value={formData.title}
  onChange={handleChange}
  size="lg"
  error={errors.title && "Title is required"}
  required
  />
  <Textarea
  mb={'8px'}
  
  label="Description"
  placeholder="Enter care plan description"
  name="description"
  value={formData.description}
  onChange={handleChange}
  error={errors.description && "Description is required"}
  required
  size="lg"
  minRows={4}
  maxRows={4}
  mt="md"
  />
  {/* {embed  && <Box mt={'20px'}>
  <Box sx={{display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
  <Button type="submit" color="blue" onClick={handleSubmit}>
  <Box mr={'4px'}><IconSparkles color={'white'}/></Box> Generate Care Plan
  </Button>
  </Box>
  </Box>}
  */}
  </form>:creatingGoalsAndTaks?<Box sx={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",height:"300px"}}>
  <Image src={aiLoader} width={'800px'} height={'200px'}/>
  <Text fw={700} c={'blue'}>Please wait while we generate care plan </Text>
  </Box>:<></>
  }
  
  </Box>
  {currentStep===1 &&<Box>
  <CarePlanComponent resources={goalsAndTasks} createCarePlan={embed?handleEmbedSubmit:createCarePlan} loading={createingCarePlan} />
  </Box>}
  {currentStep===2 &&<Box>
  <Tabs variant="pills" defaultValue="Raw">
  <Tabs.List >
  <Box sx={{display:"flex",flexDirection:"row",backgroundColor:"#f5f6f6",padding:"4px",borderRadius:"6px"}}>
  <Tabs.Tab value="Raw" >Care Plan</Tabs.Tab>
  <Tabs.Tab value="Json" >FHIR Response</Tabs.Tab>
  </Box>
  </Tabs.List>
  
  <Tabs.Panel value="Raw" pt="xs">
  <CarePlanResource carePlan={carePlanResource}/>
  </Tabs.Panel>
  
  <Tabs.Panel value="Json" pt="xs">
  <Text fz="lg" fw={700} mb={'sm'} >
  FHIR Response
  </Text>
  <Text
  className={classes.text}
  >
  <pre>{JSON.stringify(carePlanResource, null, 2)}</pre>
  </Text>
  
  </Tabs.Panel>
  
  </Tabs>
  
  </Box>}
  <Modal
        opened={embedModal}
        onClose={() => {setEmbedModal(false)
          setCurrentStep(0)
        }
        }
        title="Selected goals and tasks care plan"
        size="lg"
        centered
      >
        <Box
        sx={{
          maxHeight: '400px',
          overflowY: 'auto',
          // border: '1px solid #ddd',
          padding: '1rem',
          '&::-webkit-scrollbar': {
            width: '2px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'black',
          },
          '&:hover::-webkit-scrollbar': {
            width: '2px',
          },
        }}
      >
        
        {embedGoals.length > 0 && (
          <>
            <ResourceDisplay resourceType="Goal" resourceData={embedGoals} />
            {embedTasks.length > 0 && <Divider my="md" />}
          </>
        )}
        {embedTasks.length > 0 && (
          <ResourceDisplay resourceType="Task" resourceData={embedTasks} />
        )}
        </Box>
      </Modal>

  </Paper>
  </>
  );
  };
  
  
  